module.exports = __webpack_public_path__ + "images/5677c96d7c25c90183b7d17cb5ff7ea5.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/memoji_up_2.png
// module id = 105
// module chunks = 0